//手机号隐藏中间几位
function phoneYm(phone){
    return phone.substr(0,3)+"****"+phone.substr(7);
}

//搜索记录存放localStorage
function saveSearchHostory(key){
    let history=getSearchHistory();
    let hasIn=false;
    for(let i=0;i<history.length;i++){
        if(history[i] == key){
            hasIn=true;
            break;
        }
    }
    if(!hasIn){
        history.push(key);
        window.localStorage.setItem('searchHistory',JSON.stringify(history));
    }
}
//取出搜索记录
function getSearchHistory(){
    let history=window.localStorage.getItem('searchHistory');
    if(history){
        history=JSON.parse(history);
    }else{
        history=[];
    }
    return history;
}
//删除搜索记录
function clearSearchHistory(){
    window.localStorage.removeItem('searchHistory');
}
//获取存储在localstorage中的用户信息
function getLocalUserInfo(){
    let uInfo=window.localStorage.getItem('userInfo');
    return uInfo ? JSON.parse(uInfo) : null;
}
//设置存储在localstorage中的用户信息
function setLocalUserInfo(data){
    window.localStorage.setItem('userInfo',JSON.stringify(data));
}
//检查手机号格式
function checkPhoneValue(phone){
    if(!(/^1[3456789]\d{9}$/.test(phone))){
        return false; 
    }else{
        return true;
    }
}


export {
    phoneYm,
    saveSearchHostory,
    getSearchHistory,
    clearSearchHistory,
    getLocalUserInfo,
    setLocalUserInfo,
    checkPhoneValue
}